<template>
  <div class="left">
    <div class="left_wrap" v-for="(item, index) in leftChart" :key="index">
      <div class="title_name">{{ item.title }}</div>
      <div :id="'chart' + item.chartId" class="charts" />
    </div>
  </div>
</template>

<script>
import localStorage from "../../libs/js/localStorage.js";
import { mapState, mapMutations } from "vuex";
import pieChart from "../../components/chart/pie.vue";
import barChart from "../../components/chart/bar.vue";
import rosePie from "../../components/chart/rose_pie.vue";
import dataUrl from "../../libs/js/interfaceAddress.js";
import echarts from "echarts";

export default {
  name: "left",
  props: {
    widthChange: {
      type: Boolean,
      default: false
    },
    leftChart: {
      type: Array,
      default: []
    }
  },
  data() {
    return {};
  },
  components: {
    rosePie,
    pieChart,
    barChart
  },
  watch: {
    leftChart: {
      handler: function(newVal) {
        if (newVal) {
          this.chartinit();
        }
      }
    }
  },
  mounted() {
    this.$bus.$off("charts_left_es").$on("charts_left_es", this.chartinit);
  },
  computed: {},
  beforeDestroy() {
    this.$bus.$off("charts_left_es", this.init);
  },
  methods: {
    chartinit() {
      this.leftChart.filter((item, i) => {
        this.$http
          .get(dataUrl.interfaceAddress.chartOptions, {
            params: { id: item.chartId }
          })
          .then(res => {
            if (res.data.code === 0) {
              var Id = res.data.body.chartId;
              var chartId = "chart" + Id;
              var chartjson = res.data.body.opetion;
              var chart_params_data = res.data.body.data;
              const keys = Object.keys(chart_params_data);
              var chart = echarts.init(document.getElementById(chartId));

              keys.filter((item, i) => {
                var reg = new RegExp(item, "g");
                const newMsg = chartjson.replace(reg, chart_params_data[item]);
                chartjson = newMsg;
              });

              var options = JSON.parse(chartjson);
              chart.setOption(options);
              // console.log("图表名称==-=="+item.title+"图表内容-=-=-=-"+JSON.stringify(options))
            } else {
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.left {
  // min-width:200px;

  width: 100%;
  height: 100%;
  color: white;
  position: relative;
  font-size: 16px;
  backdrop-filter: blur(10px);

  .title_name {
    width: 50%;
    //   font-size: 18px;
    font-size: 20px;
    line-height: 20px;
    color: #17c4e4;
    font-weight: bold;
    text-align: center;
    margin-left: 10px;
    display: block;
    // background:-webkit-linear-gradient(left,#17c4e4,#fff 25%,#17c4e4 50%,#fff 75%,#17c4e4);
    // color:transparent;
    // -webkit-background-clip:text;
    // background-size:200% 100%;
    // animation:masked-animation 1s infinite linear;
  }

  @-webkit-keyframes masked-animation {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -100% 0;
    }
  }

  .left_wrap {
    // background: url(../../../static/img/left.png) no-repeat;

    margin-top: 4%;
    width: 100%;
    height: 31%;
    position: relative;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/left.png)
      no-repeat;
    background-size: 100% 100%;
    margin-left: 9px;
    // background-color: rgba(2, 2, 2, 0);
    border-radius: 22px;
    .charts {
      height: 90%;
      width: 100%;
    }
  }

  .status {
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/left.png)
      no-repeat;
    background-size: 100% 100%;
    margin-left: 18px;
  }

  .type {
    //   height: 266px;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/left.png)
      no-repeat;
    background-size: 100% 100%;
    margin-left: 18px;
    //   margin-bottom: 30px;
    .type_pie {
      // margin-top: 20px;
    }
  }

  .Summary {
    //   height: 306px;  //大
    //  height:277px;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/left.png)
      no-repeat;
    background-size: 100% 100%;
    margin-left: 18px;
    //   margin-bottom: 30px;
    .Summary_bar {
      // margin-top: 20px;
    }
  }
}

.left_min {
  .title_name {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/left_content.vue